import React, {useContext, useEffect, useState} from 'react';
import {Table} from 'react-bootstrap';
import ProductRow from './ProductRow';
import AuthContext from '../../authentication/AuthContext';
import axios from 'axios';
import {useAlert} from 'react-alert';
import UserContext from '../../user/UserContext';
import LoadingSpinner from '../../common/LoadingSpinner';
import CreateOrderLink from '../../common/CreateOrderLink';
import ProductSearchWithFiltersPane from '../../common/search/ProductSearchWithFiltersPane';
import ProductSearch from "../../common/search/ProductSearch";
import {faArrowDown, faArrowUp} from "@fortawesome/free-solid-svg-icons";

export default function ProductRange() {
    const [loading, setLoading] = useState(true);
    const [bestsellers, setBestsellers] = useState([]);
    const [searchResults, setSearchResults] = useState([]);
    const [searched, setSearched] = useState(false);

    const cas = useContext(AuthContext);
    const {userDetails} = useContext(UserContext);
    const alert = useAlert();

    // Once A/B testing of search filters pane is done, either remove ProductSearch
    // and rename ProductSearchWithFiltersPane to it, or remove ProductSearchWithFiltersPane,
    // both in Product Range and Order details views
    const filtersPaneControlGroupName = 'Filters Pane Control Group';

    const noResultsRow =
        <tr>
            <td colSpan={9} className={'no-results'}>
                Your search returned no results. Please try again.
            </td>
        </tr>
    ;

    const getBestsellers = () => {
        if (userDetails.currentFranchise) {
            setLoading(true);
            setSearched(false);
            axios
                .get(
                    window.CONFIG['ws.activoc-web-order-api.products.bestselling.productRange'].replace(
                        '{franchiseCode}',
                        userDetails.currentFranchise.code
                    ),
                    {
                        headers: {
                            Authorization: cas,
                            'Content-Type': 'application/json'
                        }
                    }
                )
                .then(response => {
                    let json = response.data;
                    if (json.length > 0) {
                        setBestsellers(
                            json.map(product => (
                                <ProductRow
                                    product={product}
                                    code={product.productCode}
                                    key={product.productCode}
                                />
                            ))
                        );
                        setLoading(false);
                    } else {
                        setBestsellers(noResultsRow);
                        setLoading(false);
                    }
                })
                .catch(() => {
                    setBestsellers(noResultsRow);
                    setLoading(false);
                    alert.error('ERROR: Unable to retrieve products.');
                });
        }
    }

    const updateSearchResults = results => {
        if (results.length > 0) {
            setSearchResults(
                results.map(product => (
                    <ProductRow
                        product={product}
                        code={product.supplierProductCode}
                        key={product.supplierProductCode}
                    />
                ))
            );
        } else {
            setSearchResults(noResultsRow);
        }
    }

    const loadedContent = searched ? searchResults : bestsellers;

    useEffect(() => {
        getBestsellers();
        // eslint-disable-next-line
    }, [cas, userDetails]);

    return (
        <>
            <div className={'page-header'}>
                <div className={'content'}>
                    <div className={'page-header-container flex'}>
                        <div>
                            <h1>Product Range</h1>
                            <span>View the entire range from CSG</span>
                        </div>
                        <CreateOrderLink/>
                    </div>
                </div>
            </div>
            <div className={'content'}>
                {userDetails?.currentFranchise?.controlGroups.includes(filtersPaneControlGroupName) ? (
                    <ProductSearchWithFiltersPane
                        resultCount={searched ? searchResults.length : bestsellers.length}
                        setSearchResults={updateSearchResults}
                        searched={searched}
                        setSearched={setSearched}
                        setLoading={setLoading}
                        showCount={true}
                    />
                ) : (
                    <ProductSearch
                        resultCount={searched ? searchResults.length : bestsellers.length}
                        setSearchResults={results => {
                            if (results.length > 0) {
                                setSearchResults(
                                    results.map(product => (
                                        <ProductRow
                                            product={product}
                                            code={product.supplierProductCode}
                                            key={product.supplierProductCode}
                                        />
                                    ))
                                );
                            } else {
                                setSearchResults(
                                    <tr>
                                        <td colSpan={9} className={'no-results'}>
                                            Your search returned no results. Please try again.
                                        </td>
                                    </tr>
                                );
                            }
                        }}
                        searched={searched}
                        setSearched={setSearched}
                        setLoading={setLoading}
                        showCount={true}
                        upIcon={faArrowUp}
                        downIcon={faArrowDown}
                    />
                )
                }
                <Table className={'product-range-table'}>
                    <thead>
                    <tr>
                        <th className={'image-column'}>Image</th>
                        <th>Code</th>
                        <th>Description</th>
                        <th>Supplier</th>
                        <th>Unit Size</th>
                        <th>Invoice Cost</th>
                        <th>RSP</th>
                        <th>Margin</th>
                        <th>VAT</th>
                    </tr>
                    {!searched && (
                        <tr className={'product-range-message'}>
                            <td colSpan={'9'}>
                                You haven't yet searched for items to add to your order. Until you do,
                                here's a selection of best-selling products.
                            </td>
                        </tr>
                    )}
                    </thead>
                    <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan={9}>
                                <LoadingSpinner/>
                            </td>
                        </tr>
                    ) : loadedContent
                    }
                    </tbody>
                </Table>
            </div>
        </>
    );
}
